import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CardBody from "components/Card/CardBody.js";
import Card from "components/MyComponents/Card.js";
import DiscountCard from "components/MyComponents/DiscountCard.js";
import EmailSendModal from "components/MyComponents/EmailSendModal";
import LoadingSpinner from "components/MyComponents/LoadingSpinner";
import axios from "axios";

import styles from "assets/jss/material-kit-react/views/loginPage.js";

import Grid from '@material-ui/core/Grid';

import { useTranslation, Trans } from 'react-i18next';
import config from "assets/config/config.json"

import ClipLoader from "react-spinners/ClipLoader";
import { withRouter } from "react-router-dom";
import { Button } from "@material-ui/core";

//IBAN and BIC validation
const ibantools = require('ibantools');
const useStyles = makeStyles(styles);



function PaymentFormComponent(props) {
    const { history } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    const [state, setState] = React.useState({
        name: undefined,
        surname: undefined,
        program: undefined,
        iban: '',
        bic: '',
        quote: 0,
        alreadyPaid: undefined,
        toPay: undefined,
        currentInstallments: 1,
        userId: undefined,
        installments: 1,
        currentIban: undefined,
        curentExpDate: undefined,
        terms: undefined,
        nextTerms: undefined,
        sepaAgreed: false,
        hasToDisplaySepa: true,
        correct: false,
        correctIban: true,
        correctBic: true,
        amount: '455',
        isExempt: false,
        isPendingFee: false,
        installmentList: undefined
    });
    const [emailSendModalOpen, setEmailSendModalOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    // similar to componentDidMount()
    React.useEffect(() => {
        if (props.userData) {
            var d = new Date(props.userData.paymentInfo?.expirationDate);
            var month = d ? d.getMonth() + 1 : 0;
            var year = d ? d.getFullYear() : 0;
            var middle = props.userData.termId.length / 2;
            var firstYear = '20' + props.userData.termId.substr(0, middle);
            var secondYear = '20' + props.userData.termId.substr(middle);
            setState({
                ...state,
                ['name']: props.userData.name,
                ['surname']: props.userData.surname,
                ['program']: props.userData.program,
                ['quote']: props.userData.amount.toFixed(2),
                ['alreadyPaid']: props.userData.alreadyPaid.toFixed(2),
                ['toPay']: (props.userData.amount - props.userData.alreadyPaid).toFixed(2),
                ['currentInstallments']: props.userData.currentInstallments === -1 ? 1 : props.userData.currentInstallments,
                ['userId']: props.userData.userId,
                ['installments']: props.userData.installments === -1 ? 1 : props.userData.installments,
                ['currentIban']: props.userData.paymentInfo?.ibanFirstLetters ? props.userData.paymentInfo?.ibanFirstLetters + "*******" + props.userData.paymentInfo?.ibanLastDigits : undefined,
                ['curentExpDate']: props.userData.paymentInfo?.expirationDate ? month + "/" + year : undefined,
                ['terms']: firstYear + "/" + secondYear,
                ['nextTerms']: (Number(firstYear) + 1) + "/" + (Number(secondYear) + 1),
                ['isExempt']: props.userData.isExempt,
                ['isPendingFee']: props.userData.isPendingFee,
                ['installmentList']: props.userData.installmentList
            });
        }
    }, [])
    
    const handlePendingFeeContactMe = () => {
        setLoading(true);
        axios.get('/subscription/pendingfeecontactme')
            .then(() => {
                setLoading(false);
                setEmailSendModalOpen(true);
                return;
            }).catch(function (error) {
                if (error.response !== undefined && error.response.status !== null && error.response.status === 400) {
                    document.getElementById("info").style.visibility = "visible";
                }
                else {
                    document.getElementById("error").style.visibility = 'visible';
                }
            });
    }

    if (!props.userData) return (null);
    else if (state.loading) {
        return (<div
            style={{
                position: 'absolute', left: '50%', top: '50%',
                transform: 'translate(-50%, -50%)'
            }}
        >
            <ClipLoader

                size={200}
                color={"#504a4a"}
            />
        </div>);
    }
    let cardsToPay = [];
    const intallmentPayment = (state.quote / state.currentInstallments);
    if (state.isExempt) {
        cardsToPay.push(<Card key={1}
            header={<>{t("ExemptText")} <a className='cl-primary-500' href='mailto:AlumniCommunity@iese.edu'>{t("ExemptEmailText")}</a></>}
            firstCard={true}></Card>)
    } else if (state.isPendingFee) {
        cardsToPay.push(<Card key={1}
            header={<>
                {t("PendingFeeText1")}<br /> 
                {t("PendingFeeText5")} <a className='cl-primary-500' href='mailto:IESEAlumniFinance@iese.edu'>IESEAlumniFinance@iese.edu</a> {t("PendingFeeText6")}<br />
                {t("PendingFeeText3")}<br />
                <Button id="PendingFeeContactMe" className="regular-b300 cl-secondary-100 myIeseButton" variant="text" onClick={handlePendingFeeContactMe}>
                    {t("PendingFeeText4")}
                </Button><br />
                <Trans i18nKey="PendingFeeText2"></Trans>
            </>}
            firstCard={true}></Card>)
    } else {
        {
            var installmentsLength = state.installmentList ? state.installmentList.length : 0;

            (function (rows, i, len) {
                while (i < len) {
                    rows.push(<Card key={i}
                        // header={(state.alreadyPaid >= intallmentPayment * i ? t("PaidText") : t("PendingText")) + " (" + i.toString().padStart(2, "0") + "/" + state.currentInstallments.toString().padStart(2, "0") + ")"}
                        firstCard={false}
                        //numberinstallment={"(" + (i + 1).toString().padStart(2, "0") + "/" + state.currentInstallments.toString().padStart(2, "0") + ") " + t("Installment")}
                        numberinstallment={t((i + 1) + "Installment") + " " + t("Installment")}
                        // numberinstallment={state.installmentList[i].dueDate}
                        body={state.installmentList[i].value.toFixed(2).toString().replace(".", ",") + "€"}
                        paid={Number(state.installmentList[i].value) == Number(state.installmentList[i].payment)}
                        footer={(Number(state.installmentList[i].value) == Number(state.installmentList[i].payment) ? t("PaidText") : t("PendingText"))}></Card>)
                    i++;
                }
                return rows;
            })(cardsToPay, 0, installmentsLength)

            // (function (rows, i, len) {
            //     while (++i <= len) {
            //         rows.push(<Card key={i}
            //             // header={(state.alreadyPaid >= intallmentPayment * i ? t("PaidText") : t("PendingText")) + " (" + i.toString().padStart(2, "0") + "/" + state.currentInstallments.toString().padStart(2, "0") + ")"}
            //             firstCard={false}
            //             // numberinstallment={"(" + i.toString().padStart(2, "0") + "/" + state.currentInstallments.toString().padStart(2, "0") + ") " + t("Installment")}
            //             numberinstallment={t(i + "Installment") + " " + t("Installment")}
            //             body={intallmentPayment.toFixed(2).toString().replace(".", ",") + "€"}
            //             paid={Number(state.alreadyPaid) >= Number((intallmentPayment * i).toFixed(2))}
            //             footer={(Number(state.alreadyPaid) >= Number((intallmentPayment * i).toFixed(2)) ? t("PaidText") : t("PendingText"))}></Card>)
            //     }
            //     return rows;
            // })(cardsToPay, 0, state.currentInstallments)
        }
    }

    let discountCards = [];
    discountCards.push(<DiscountCard key={"1"}
        imgpath={"/img/discounts/Learn.png"}
        header={t("DiscountCardHeader1")}
        body={t("DiscountCardBody1")}
        footerpath={t("DiscountCardPath1")}></DiscountCard>);
    discountCards.push(<DiscountCard key={"2"}
        imgpath={"/img/discounts/Grow.png"}
        header={t("DiscountCardHeader2")}
        body={t("DiscountCardBody2")}
        footerpath={t("DiscountCardPath2")}></DiscountCard>);
    discountCards.push(<DiscountCard key={"3"}
        imgpath={"/img/discounts/Connect.png"}
        header={t("DiscountCardHeader3")}
        body={t("DiscountCardBody3")}
        footerpath={t("DiscountCardPath3")}></DiscountCard>);
    discountCards.push(<DiscountCard key={"4"}
        imgpath={"/img/discounts/Impact.png"}
        header={t("DiscountCardHeader4")}
        body={t("DiscountCardBody4")}
        footerpath={t("DiscountCardPath4")}></DiscountCard>);
    return (
        <GridContainer justify="center">
            {loading ? <LoadingSpinner /> : ""}
            <GridItem xs={12} sm={12} md={12}>
                <form className={classes.form} style={{ borderRadius: "8px" }}>
                    <CardBody>
                        <Grid container className="PaymentOverviewBackgroundColor" justify="center">
                            <Grid className="paddingLeftRight64" item xs={12} sm={12} md={12}>
                                <div className={"semibold-h500 cl-secondary-100 paddingTop60"}> {t("MainPageTitle")}</div>
                                <div className={"semibold-h300 cl-secondary-100 paddingTop60"}> {t("MainPageSubtitle")}</div>
                                <div className={classes.spacing}></div>
                                <div className="myCardWrapper">
                                    {(!state.isExempt && !state.isPendingFee) &&
                                        <Card firstCard={true} header={t("FeeText")} body={state.quote.toString().replace(".", ",") + "€"} footer={t("CourseText") + " " + state.terms}></Card>
                                    }
                                    {cardsToPay}
                                </div>
                            </Grid>
                        </Grid>
                        <hr className="customHr marginLeftRight64 paddingLeftRight64 customHrWidthLeftRightMobile" />
                        {(!state.isExempt && !state.isPendingFee) &&
                            <Grid className="paddingLeftRight64" item xs={12} sm={12} md={12}>
                                <div className="flexWrapper equals">
                                    <div className={classes.gridFirstColumn}>
                                        <div className="semibold-h200 paddingBottom16">{t("CardDetailsText")}</div>
                                        <div className="semibold-b100 cl-secondary-500 paddingBottom10">{t('InstallmentsDescriptionPart1')}{state.currentInstallments}{t("InstallmentsDescriptionPart2")}</div>
                                        <div className="semibold-b100 cl-secondary-500 paddingBottom10">{t(state.installments + "InstallmentLiteral")} {t("InstallmentsFutureDescriptionPart1")} {state.nextTerms}</div>
                                        <div className="semibold-b100 cl-secondary-500">{state.currentIban ? t("Bank") + ": " + state.currentIban : (state.curentExpDate ? t("Card") + " " + t("CardExpireDate") + state.curentExpDate : "")}</div>
                                    </div>
                                    <div>
                                        {state.currentIban ?
                                            <div className="myPaymentCard">
                                                <div className="paddingBottom20">
                                                    <div className="flexWrapper">
                                                        <div>
                                                            <div className="semibold-b300">{t("Bank")}</div>
                                                        </div>
                                                        <div>
                                                            <div className="textRight">
                                                                <a className='semibold-b300 anchor'
                                                                    onClick={() => { history.push('/paymentoverview') }}>
                                                                    {t("EditBtnText")}<img loading="lazy"
                                                                        className="gotopageimg"
                                                                        alt="Edit Bank Account" src="/img/rightarrow.svg" /></a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="regular-b200 paddingBottom20">{t("BankAccountDescription")}</div>
                                                {/* <div>
                                                    {state.currentIban ?
                                                        <span className="regular-b200 cl-secondary-500">{state.currentIban}</span>
                                                        : ""}</div> */}
                                            </div>
                                            :
                                            (state.curentExpDate ?
                                                <div className="myPaymentCard">
                                                    <div className="paddingBottom20">
                                                        <div className="flexWrapper">
                                                            <div>
                                                                <div className="semibold-b300">{t("Card")}</div>
                                                            </div>
                                                            <div>
                                                                <div className="textRight">
                                                                    <a className='semibold-b300 anchor'
                                                                        onClick={() => { history.push('/paymentoverview') }}>
                                                                        {t("EditBtnText")}<img loading="lazy"
                                                                            className="gotopageimg"
                                                                            alt="Edit Credit Card" src="/img/rightarrow.svg" /></a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="regular-b200 paddingBottom20">{t("CreditCardDescription")}</div>
                                                    {/* <div>{state.curentExpDate ? <span className="regular-b200 cl-secondary-500">{state.curentExpDate}</span>
                                                        : ""}</div> */}
                                                </div> : ""
                                                // <div className="myPaymentCard">
                                                //     <div className="paddingBottom20">
                                                //         <div className="flexWrapper">
                                                //             <div>
                                                //                 <div className="semibold-b300">{t("CardDetailsDescriptionText")}</div>
                                                //             </div>
                                                //             <div>
                                                //                 <div className="textRight">
                                                //                     <a className='semibold-b300 anchor'
                                                //                         onClick={() => { history.push('/paymentoverview') }}>
                                                //                         {t("EditBtnText")}<img loading="lazy"
                                                //                             className="gotopageimg"
                                                //                             alt="Edit Payment Method" src="/img/rightarrow.svg" /></a>
                                                //                 </div>
                                                //             </div>
                                                //         </div>
                                                //     </div>
                                                // </div>
                                                )}
                                    </div>
                                </div>
                            </Grid>
                        }
                        <hr className="customHr marginLeftRight64 paddingLeftRight64 customHrWidthLeftRightMobile" />
                        <Grid className="paddingLeftRight64" item xs={12} sm={12} md={12}>
                            <div className="flexWrapper paddingBottom30">
                                <div>
                                    <div className="semibold-h200">{t("MainPageSecondSectionTitle")}</div>
                                </div>
                                <div>
                                    <div className="textRight">
                                        <a className='semibold-b300 anchor'
                                            onClick={() => { window.open('https://alumni.iese.edu/', '_blank') }}>
                                            {t("GoToPageButton")}<img loading="lazy"
                                                className="gotopageimg"
                                                alt="GoToPage" src="/img/gotopage.svg" /></a>
                                    </div>
                                </div>
                            </div>
                            <div className="myCardWrapper">
                                {discountCards}
                            </div>
                        </Grid>
                    </CardBody>
                </form>
             <form id="elForm" action={props.userData.redsysService} method="POST" >
                    <input type="hidden" name="Ds_SignatureVersion" value={'HMAC_SHA256_V1'} />
                    <input id="merchantParams" type="hidden" name="Ds_MerchantParameters" value={""} />
                    <input id="signature" type="hidden" name="Ds_Signature" value={""} />
                </form>
            </GridItem>
            <EmailSendModal show={emailSendModalOpen} close={() => setEmailSendModalOpen(false)} />
        </GridContainer>
    );
}
export default withRouter(PaymentFormComponent);